import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PeriodicReportComponent } from './periodic-report.component';
import { PdfMergeDialogComponent } from './pdf-merge-dialog/pdf-merge-dialog.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { CustomDropdownModule } from 'src/app/shared/components/custom-dropdown/custom-dropdown.module';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { MatSortModule } from '@angular/material/sort';
import { CustomInputModule } from 'src/app/shared/components/custom-input/custom-input.module';
import { PeriodicReportRoutingModule } from './periodic-report-routing.module';



@NgModule({
  declarations: [
    PeriodicReportComponent,
    PdfMergeDialogComponent
  ],
  imports: [
    CommonModule,
   CustomDatePickerModule,
           CustomDropdownModule,
           FormsModule,
           ReactiveFormsModule,
           MaterialModule,
           MatPaginatorModule,
           CustomInputModule,
           MatSortModule,
           PeriodicReportRoutingModule
  ],
  exports:[
    PeriodicReportComponent
  ]
})
export class PeriodicReportModule { }
